<template>
  <div class="statistics">
    <topSearchForm @search="query" @export="daochu">
      <el-form :inline="true" class="curForm" label-position="left">
        <el-form-item label="机构名称" class="item">
          <el-select v-model="barform.mechanId" clearable filterable>
            <el-option :label="dept.shortName" :value="dept.id" v-for="(dept,index) in selectList" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="保单号" class="item">
          <el-input
            type="text"
            placeholder="请输入保单号"
            v-model="barform.policyNo"
            class="code"
          ></el-input>
        </el-form-item>
        <el-form-item label="时间" class="item1">
          <a-range-picker v-model="barform.date" format="yyyy-MM-DD" valueFormat="yyyy-MM-DD" separator="至">
            <i class="icon-riqixuanze" slot="suffixIcon"></i>
          </a-range-picker>
        </el-form-item>
      </el-form>
    </topSearchForm>
    <div class="content">
      <span class="red">统计子机构已过犹豫期（含续期）保单业绩</span>
      <el-table
        class="list-table"
        border
        v-loading="listLoading"
        :data="tableData"
        tooltip-effect="dark"
      >
        <emptyBox slot="empty"></emptyBox>
        <el-table-column type="index" min-width="60px"></el-table-column>
        <el-table-column
          property="mechanName"
          label="机构名称"
          min-width="180"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column property="policyNo" label="保单号" min-width="200" show-overflow-tooltip></el-table-column>
        <el-table-column
          property="productName"
          label="产品名称"
          min-width="200"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column property="waverLimit" label="犹豫期" min-width="120" show-overflow-tooltip></el-table-column>
        <el-table-column property="payTime" label="出单时间" min-width="150" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.payTime | timeSubstr(0, 16) }}</span>
          </template>
        </el-table-column>
        <el-table-column property="fee" label="保费（元）" min-width="100" show-overflow-tooltip></el-table-column>
        <el-table-column property="payNum" label="年限" min-width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.payNum == 1">首年</span>
            <span v-else>第{{ scope.row.payNum }}年</span>
          </template>
        </el-table-column>
        <el-table-column property="income" label="服务费（元）" min-width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.income || "--" }}</span>
            <el-popover placement="top" trigger="hover">
              <div>
                <span>服务费：</span>
                <span>{{ scope.row.income || "--" }}</span>
              </div>
              <div>
                <span>主险服务费：</span>
                <span>{{ scope.row.mainTotalIncomes || "--" }}</span>
              </div>
              <div>
                <span>附加险服务费：</span>
                <span>{{ scope.row.additionIncomes || "--" }}</span>
              </div>
              <span slot="reference" class="wenhao">?</span>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          property="totalIncome"
          label="机构服务费（元）"
          min-width="140"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="我的利润（元）" min-width="140" fixed="right" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.profit }}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        :current-page.sync="pageNum"
        @size-change="pageNum=1;pageSize=$event;getList(1)"
        :layout="$tools.pageLayout"
        @current-change="getList"
        :total="total"
        :page-size="pageSize"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import topSearchForm from "@/components/topSearchForm";
//当前实例组件
export default {
  data: () => ({
    listLoading:true,
    barform: {
      policyNo: "",
      mechanId: "",
      sureDate: ""
    },
    pageSize: 10,
    total: 0,
    twoMechanId: "",
    tableData: [],
    sureDate: "",
    restaurants: [],
    pageNum: 1,
    selectList:[],
  }),
  components: {topSearchForm},
  created() {
    this.getList();
    this.getChildList(); //二级机构查询
  },
  methods: {
     // 获取机构/员工列表
    getChildList(){
      this.$http({
        url:'/master/mechan/queryChildList',
        type:'PUT',
        params:{
          level:'2'
        },
      }).then(res=>{
        if(res.httpCode==200){
          this.selectList=res.data
        }
      }).catch(e=>{})
    },
    //导出
    daochu: function() {
      const params = this.getParams();
      this.$tools.daochu("/master/level2/achievement/export",params);
    },
    //搜索点击
    query: function() {
      this.pageNum = 1;
      this.getList(1);
    },
    getSummaries: function(param) {
      //合计
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (
          index === 0 ||
          index === 1 ||
          index === 2 ||
          index === 3 ||
          index === 4 ||
          index === 6
        ) {
          sums[index] = "——";
          return;
        }
        let values;
        values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = sums[index].toFixed(2);
        } else {
          sums[index] = "N/A";
        }
      });
      return sums;
    },
    getParams() {
      const params = {
        startDate: this.barform.startDate,
        endDate: this.barform.endDate,
        policyNo: this.barform.policyNo,
        mechanId: this.barform.mechanId
      };
      return params;
    },
    //获取主数据
    getList: function(num) {
      // var sureDate = '';
      // var time = new Date()
      // var year = time.getFullYear();
      // var month = time.getMonth() + 1;
      // month = (month < 10 ? "0" + month : month);
      // if (!this.barform.sureDate) {
      //     this.barform.sureDate = year + '-' + month
      // }
      if (this.barform.date && this.barform.date.length == 2) {
        this.barform.startDate = this.barform.date[0];
        this.barform.endDate = this.barform.date[1];
      } else {
        this.barform.startDate = "";
        this.barform.endDate = "";
      }
      const params = this.getParams();
      params.pageSize = 10;
      params.pageNum = num;
      this.listLoading = true;
      this.$http({
        url: "/master/level2/achievement/list",
        type: "put",
        params: params
      }).then(data => {
        this.listLoading = false;
        this.tableData = data.data;
        for (var i = 0; i < data.data.length; i++) {
          if (data.data[i].oneSubsidyCommission) {
            data.data[i].commissionTotal = (
              data.data[i].oneCommission * 1 +
              data.data[i].oneSubsidyCommission * 1
            ).toFixed(2);
          } else {
            data.data[i].commissionTotal = (
              data.data[i].oneCommission * 1
            ).toFixed(2);
          }
        }
        this.total = data.total;
      });
    }
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
.curForm{
  .item{
    width: 30%;
  }
  .item1{
    width: 40%;
  }
}
</style>